import PinInputControl from "components/common/PinInput/PinInputControl";
import PinStatusIcon from "components/common/PinInput/PinStatusIcon";
import * as React from "react";
import styled from "styled-components";
import PinDivider from "./PinDivider";
import PinInputWrapper from "./PinInputWrapper";

const InputContainer = styled.div`
  position: relative;
`;

interface IProps {
  pin?: string;
  goodPin?: boolean;
  wrongPin?: boolean;
  loading?: boolean;
  small?: boolean;
  onClick?: any;
  focused?: boolean;
}

const PinInput = ({
  pin,
  goodPin,
  small,
  onClick,
  focused,
  wrongPin,
  loading
}: IProps): any => (
  <PinInputWrapper onClick={onClick} small={small}>
    <InputContainer>
      <PinInputControl
        value={pin}
        maxLength={4}
        goodPin={goodPin}
        wrongPin={wrongPin}
        readOnly
        focused={focused}
      />
      {[{ left: 55 }, { left: 110 }, { left: 165 }].map(
        (pinDivider: any, index: number) => (
          <PinDivider
            style={{ left: pinDivider.left }}
            key={index}
            focused={focused}
          />
        )
      )}
    </InputContainer>
    {wrongPin && <PinStatusIcon wrongPin icon="times" />}
    {goodPin && <PinStatusIcon goodPin icon="check" />}
    {loading && <PinStatusIcon icon="spinner" spin />}
  </PinInputWrapper>
);

export default PinInput;



// WEBPACK FOOTER //
// ./src/components/common/PinInput/index.tsx